import Vue from "vue";
import VueRouter from "vue-router";
import LoginScreen from "../screens/LoginScreen.vue";
import MainScreen from "../screens/MainScreen.vue";
import { checkState } from "../api/index";
import { Message } from "element-ui";

Vue.use(VueRouter);

// TODO 正式部署时全部改为懒加载模式可以加快加载速度

const routes = [
  {
    path: "/",
    name: "LoginScreen",
    component: LoginScreen,
  },
  {
    path: "/yj",
    name: "MainScreen",
    component: MainScreen,
    children: [
      {
        path: "home",
        component: () => import("../views/Home"),
      },
      {
        path: "upload",
        component: () => import("../views/Upload"),
      },
      {
        path: "work",
        component: () => import("../views/Work"),
      },
      {
        path: "video",
        component: () => import("../views/Video"),
      },
      {
        path: "video:id",
        component: () => import("../components/VideoPage"),
      },
      {
        path: "subject",
        component: () => import("../components/newVideoForm"),
      },
      {
        path: "workform",
        component: () => import("../components/WorkForm"),
      },
      {
        path: "source",
        component: () => import("../components/SourceForm"),
      },
      {
        path: "mine",
        component: () => import("../views/Mine"),
      },
      {
        path: "review",
        component: () => import("../views/Review"),
      },
      {
        path: "password",
        component: () => import("../views/Password"),
      },
      {
        path: "query-stu",
        component: () => import("../views/QueryStu"),
      },
      {
        path: "manage-stu",
        component: () => import("../views/ManageStu"),
      },
      {
        path: "manage-tea",
        component: () => import("../views/ManageTea"),
      },
      {
        path: "manage-sub",
        component: () => import("../views/ManageSub"),
      },
      {
        path: "manage-service-content",
        component: () => import("../views/ManageServiceContent"),
      },
      {
        path: "query-sign",
        component: () => import("../views/ManageSign"),
      },
      {
        path: "manage-class",
        component: () => import("../views/ManageClass"),
      },
      {
        path: "manage-source",
        component: () => import("../views/ManageSource"),
      },
      {
        path: "import-hetong",
        component: () => import("../views/ImportStu"),
      },
      {
        path: "import-tea",
        component: () => import("../views/ImportTea"),
      },
      
      // ============ 合同申请相关路由 ============
      {
        path: "contract/apply",
        name: "ContractApply",
        component: () => import("../views/ContractApply"),
        meta: { 
          requiresAuth: true,
          title: "合同修改申请"
        }
      },
      {
        path: "contract/approval",
        name: "ContractApproval",
        component: () => import("../views/ContractApproval"),
        meta: { 
          requiresAuth: true, 
          requiresAdmin: true,
          title: "合同审批管理"
        }
      },
      {
        path: "contract/apply/detail",
        name: "ApplyDetail",
        component: () => import("../views/ApplyDetailPage"),
        meta: { 
          requiresAuth: true,
          title: "申请详情"
        }
      },
      {
        path: "contract/my-apply",
        name: "MyApply",
        component: () => import("../views/MyApply"),
        meta: { 
          requiresAuth: true,
          title: "我的申请"
        }
      },
      // ============ 可选的额外路由（如果需要单独访问） ============
      {
        path: "contract/pending",
        name: "ContractPending",
        component: () => import("../components/PendingApproval"),
        meta: { 
          requiresAuth: true,
          requiresAdmin: true,
          title: "待审批列表"
        }
      },
      {
        path: "contract/approved",
        name: "ContractApproved",
        component: () => import("../components/ApprovedList"),
        meta: { 
          requiresAuth: true,
          requiresAdmin: true,
          title: "已审批列表"
        }
      },
      {
        path: "contract/rejected",
        name: "ContractRejected",
        component: () => import("../components/RejectedList"),
        meta: { 
          requiresAuth: true,
          title: "已拒绝列表"
        }
      },
      {
        path: "contract/effective",
        name: "ContractEffective",
        component: () => import("../components/EffectiveList"),
        meta: { 
          requiresAuth: true,
          title: "已生效列表"
        }
      },
      // ============ 合同历史记录（可选） ============
      // {
      //   path: "contract/history",
      //   name: "ContractHistory",
      //   component: () => import("../views/ContractHistory"), // 需要创建这个文件
      //   meta: { 
      //     requiresAuth: true,
      //     title: "合同修改历史"
      //   }
      // }
    ],
  },
  {
    path: "/404",
    component: () => import("../views/404.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 全局前置守卫
let loginChecked = false;
let loginChecking = false;

router.beforeEach((to, from, next) => {
  // 排除附件查看请求
  if (to.path === '/yj/work' && to.query.action === 'view') {
    next();
    return;
  }

  // 排除登录页面
  if (to.name === "LoginScreen") {
    next();
    return;
  }

  // 如果已经检查过登录状态，直接放行
  if (loginChecked) {
    next();
    return;
  }

  // 如果正在检查中，等待
  if (loginChecking) {
    const checkInterval = setInterval(() => {
      if (!loginChecking) {
        clearInterval(checkInterval);
        next();
      }
    }, 100);
    return;
  }

  if (to.path !== "/") {
    loginChecking = true;
    
    checkState()
      .then((res) => {
        console.log("登陆状态检测请求成功", res);
        loginChecked = true;
        loginChecking = false;
        next();
      })
      .catch((err) => {
        console.log("登陆状态检测请求失败", err);
        loginChecked = false;
        loginChecking = false;
        router.push({ name: "LoginScreen" });
        Message.error({
          message: "未登陆或登陆信息已过期，请重新登陆",
        });
      });
  } else {
    next();
  }
});

// 添加登出时清除缓存的方法
export const resetLoginCheck = () => {
  loginChecked = false;
};

export default router;
